import * as React from "react";
import AppRouter from "../../routes/AppRouter";
import { useSession } from "../../state/api/session/useSession";
import LogInPage from "../pages/LogInPage";
import "./App.css";
import PageLoader from "./loader/PageLoader";
import SideNav from "./nav/SideNav";
import AdminPill from "./session/AdminPill";

export interface AppProps {
  title: string;
  isOfficeInitialized: boolean;
}

export default function App({ isOfficeInitialized }: AppProps) {

  const {
    isLoading,
    isFetching,
    session
  } = useSession();


  if (!isOfficeInitialized) return <PageLoader />

  if (isLoading && isFetching) return <PageLoader />

  if (!session) return <LogInPage />

  return (
    <div className="vh-100 vw-100 d-flex flex-row">
      <SideNav />
      <div className="app-content vw-100 vh-100 d-flex flex-column">
        <AppRouter />
      </div>
      <AdminPill />
    </div>
  );
}
